<template>
  <div>
    <div class="buttons-cart row">
      <div class="col-12 warning-text" v-if="this.specialPoints == 1">{{ Lang.get('js.cart.warning') }}</div>
      <div class="left col-12 col-sm-6 mb-3 mb-sm-0 text-center">
        <div @click="handlerClose" class="my-cart-button grey">{{ Lang.get('js.cart_continue') }}</div>
      </div>
      <div class="right col-12 col-sm-6 text-center text-md-left">
        <a :href="Lang.locale === defaultLanguage ? `/cart/${orderId}` : `/${Lang.locale}/cart/${orderId}`"
           class="my-cart-button">{{ Lang.get('js.cart_order') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cart-modal',
  props: ['specialPoints'],
  data() {
    return {
      Lang,
      orderId: window.cart.orderId,
      defaultLanguage
    }
  },
  methods: {
    handlerClose() {
      this.$emit('close-cart');
    },
  },
  mounted() {

  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/order/CartModal.vue